import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Import from project
import "../../Style/actionstyle.scss";
import MandateForm from "./Form/MandateForm";
import DialogDelete from "../../Utils/DialogDelete";

import { AuthContext } from "../../Context/AuthContext";
import { useDeleteMandate } from "./Delete/useDeleteMandate";

export default function MandateAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const { handleDelete, loading } = useDeleteMandate({
    handleClose: handleCloseDel,
    setRefetch,
  });
  const handleDeleteData = () => {
    handleDelete(editData?._id);
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {/* {hasPermission(userLogin?.user?.role, "update:user") && ( */}
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        {/* )} */}

        {/* {hasPermission(userLogin?.user?.role, "delete:user") && ( */}
        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        {/* )} */}
      </Stack>

      {openEdit && (
        <MandateForm
          open={openEdit}
          handleClose={handleCloseEdit}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle="Update"
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          loading={loading}
          editData={editData}
          handleClose={handleCloseDel}
          handleDelete={handleDeleteData}
          deleteTitle={t("modal_title_delete_mandate")}
        />
      )}
    </div>
  );
}
